var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9794 1.81542C15.7914 1.10553 15.2403 0.545944 14.5414 0.354789C13.2647 -2.46919e-08 8.15759 0 8.15759 0C8.15759 0 3.05071 0 1.77396 0.341351C1.08853 0.5323 0.524011 1.10566 0.335999 1.81542C0 3.11201 0 5.801 0 5.801C0 5.801 0 8.50351 0.335999 9.78653C0.524189 10.4963 1.07509 11.0559 1.77406 11.2471C3.06414 11.602 8.15779 11.602 8.15779 11.602C8.15779 11.602 13.2647 11.602 14.5414 11.2606C15.2404 11.0695 15.7914 10.51 15.9796 9.80018C16.3155 8.50349 16.3155 5.81462 16.3155 5.81462C16.3155 5.81462 16.3289 3.11198 15.9794 1.81542ZM6.53159 8.28514V3.31678L10.7784 5.80095L6.53159 8.28514Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.a5686afb2ec949237310a2077a720d0e.svg";
export { ForwardRef as ReactComponent };